import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import flagBrazil from "../../imagens/flags/bandeiraBrasil.png"
import flagEUA from "../../imagens/flags/bandeiraEUA.png"
import flagEU from "../../imagens/flags/EU.png"

import ReCAPTCHA from "react-google-recaptcha";
import "./pageTestContactUs.css";
import { useNavigate } from "react-router-dom";
import emailjs from '@emailjs/browser';

const ContactUsComponent = () => {
    const [alertMessage, setAlertMessage] = useState(null);
    const [alertType, setAlertType] = useState(null);
    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const navigate = useNavigate(); // Hook para redirecionar

    // Função para validar o domínio do e-mail
    const isValidDomain = async (email) => {
        const domain = email.split("@")[1];
        try {
            const response = await fetch(`https://dns.google/resolve?name=${domain}&type=MX`);
            const data = await response.json();
            return data.Answer && data.Answer.length > 0;
        } catch (error) {
            return false;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("Tentando enviar e-mail com os seguintes dados:");
        console.log("Service ID:", process.env.REACT_APP_SERVICE_ID);
        console.log("Template ID:", process.env.REACT_APP_TEMPLATE_ID);
        console.log("Public Key:", process.env.REACT_APP_PUBLI);

        const formData = new FormData(e.target);
        const email = formData.get("email");

        // Validação do domínio do e-mail
        if (!(await isValidDomain(email))) {
            setAlertMessage("Erro: domínio de e-mail inválido. Verifique o endereço e tente novamente.");
            setAlertType("danger");
            return;
        }

        // Validação do reCAPTCHA
        if (!recaptchaValue) {
            setAlertMessage("Por favor, complete o reCAPTCHA.");
            setAlertType("danger");
            return;
        }

        // Envio do e-mail com EmailJS
        emailjs
            .sendForm(
                process.env.REACT_APP_SERVICE_ID,  // Service ID
                process.env.REACT_APP_TEMPLATE_ID, // Template ID
                e.target,
                process.env.REACT_APP_PUBLI         // Public Key

            )
            .then(
                () => {
                    setAlertMessage("E-mail enviado com sucesso!");
                    setAlertType("success");
                    e.target.reset();

                    // Redireciona para a página /ContactUs
                    setTimeout(() => {
                        navigate("/ContactUs");
                    });
                },
                (error) => {
                    console.error("Erro ao enviar e-mail:", error);

                    setAlertMessage("Erro ao enviar o e-mail. Tente novamente mais tarde.");
                    setAlertType("danger");
                }
            );
    };

    const handleRecaptchaChange = (value) => {
        setRecaptchaValue(value);
    };
    return (
        <div>
            <section className="container w-100">
                <div className="row">
                    <h2 className="bgColorCustom text-center my-4">Contact Us</h2>
                    <div className="col-lg-6 col-md-12 mb-4 p-0">
                        <div className="d-flex flex-column align-items-start row-gap-5 custom-test">
                            <div className="custom-margin d-flex align-items-start my-4">
                                <div className="d-flex flex-column pe-4 pt-3">
                                    <span><img src={flagBrazil} alt="Brazil Flag" className="flag-icon py-5" /></span>
                                    <span><img src={flagEUA} alt="EUA Flag" className="flag-icon py-4"/></span>
                                    <span><img src={flagEU} alt="Europe Flag" className="flag-icon-EU" /></span>
                                </div>
                                <div>
                                    <h2 className="text-start ps-2 bgColorCustom">Locations</h2>
                                    <div className="border-custom">
                                        <h4 className="mt-3 bgColorCustom">SSA Automotive Systems</h4>
                                        <p className="text-start ps-2 bgColorCustom">
                                            - Av. das indústrias, 1001
                                            <br />
                                            Ouro Fino, Brazil 
                                        </p>

                                        <h4 className="mt-5 bgColorCustom">SPI Automotive NA Inc</h4>
                                        <p className="text-start ps-2 bgColorCustom">
                                            - 1862, Start-Batt drive, 48309,
                                            <br />
                                            Rochester Hills
                                            , Michigan - USA
                                        </p>
                                        <h4 className="mt-5 bgColorCustom">SPI Automotive Europe</h4>
                                        <p className="text-start ps-2 bgColorCustom">
                                            - Calle Gabiria 110-148
                                            <br />
                                            Polígono Industrial Gabiria
                                            <br />
                                            20305 Irun (Gipuzkoa)
                                            - <span>Spain</span>
                                            <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="custom-margin d-flex align-items-start ps-5">
                                <FontAwesomeIcon
                                    icon={faPhone}
                                    className="custom-icon-contactus-phone align-self-center me-5 bgColorCustom"
                                ></FontAwesomeIcon>
                                <div>
                                    <h2 className="bgColorCustom ps-2">Phone</h2>
                                    <div className="d-flex">
                                        <p className="border-custom m-0 bgColorCustom">
                                            +1 2482375398
                                        </p>
                                    </div>
                                    <p className="border-custom m-0 ps-2 bgColorCustom fw-bold">
                                        Aritz Nogues
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        {alertMessage && (
                            <div className={`alert alert-${alertType} mt-3`} role="alert">
                                {alertMessage}
                            </div>
                        )}

                        <form onSubmit={handleSubmit}>
                            <h2 className="text-center bgColorCustom">Send Message</h2>
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Name:
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">
                                    Email:
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="form-control"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="Number" className="form-label">
                                    Number:
                                </label>
                                <input id="Number" name="Number" className="form-control" required />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="subject" className="form-label">
                                    Subject:
                                </label>
                                <input id="subject" name="subject" className="form-control" required />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="message" className="form-label">
                                    Type your message:
                                </label>
                                <textarea
                                    id="message"
                                    name="message"
                                    className="form-control"
                                    rows="5"
                                    required
                                ></textarea>
                            </div>
                            <div className="mb-3">
                                <ReCAPTCHA
                                    sitekey="6LfltZkqAAAAAMl7b8dSoSs0zqfmtW07rtqST7cb"
                                    onChange={handleRecaptchaChange}
                                />
                            </div>
                            <button type="submit" className="btn btn-primary mb-3">
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactUsComponent;
